<template>
    <div class="pjmain">
        <div class="content">
            <div class="pjxqtitle">
                <span>服务内容：{{list.nr}}</span>
                <span>员工姓名：{{list.name}}</span>
                <span>服务时间：{{list.time}}</span>
            </div>
            <div class="dx">
                <div class="daxing mt10">
                    <span>服务评价</span>
                    <van-rate v-model="fwpj" allow-half :readonly='!ispj'/>
                </div>
                <div class="daxing mt10">
                    <span>服务效率</span>
                    <van-rate v-model="fwxl" allow-half :readonly='!ispj'/>
                </div>
            </div>
            <div class="bxqk mt10">
                <p v-show="!ispj">内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容</p>
                <textarea v-show="ispj" v-model="qk" placeholder="描述..."></textarea>
            </div>
            <button class="tijiao" v-if="ispj">发布</button>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            list:{
                nr:'管道维修',
                name:'张三',
                work:'巡逻员',
                time:'2020-01-01',
            },
            ispj:true,//是否可以评价
            fwpj:3,
            fwxl:3,
            qk:''
        }
    },
    mounted() {
        var that = this
        if(that.$route.query.status == 0){
            that.ispj=true
        }else{
            that.ispj=false
        }
    },
    methods: {
        getImg(i,name){
            var that = this
            // ImagePreview({
            //     images: that.list[name].map(item=>{
            //         return that.Zfip.ip+item.src
            //     }),
            //     showIndex: true,
            //     loop: true,
            //     startPosition: i
            // });
        },
        //上传照片的接口
        afterRead(file){
            var that = this
            if(file.length>=2){
                file.map(item=>{
                    let content = item.file;
                    let data = new FormData();
                    data.append('file',content);
                    axios.post(that.Zfip.ip+'/websites/_ext/zhsq/czfmobile/savePicture.jsp',data)
                    .then(result=>{
                        if(!result.data.success){
                            that.$toast.fail('图片上传失败，请重试！');
                            item.status='failed'
                            item.message= '上传失败'
                        }else{
                            item.srcs = result.data.result.src
                        }
                    })
                })
            }else{
                let content = file.file;
                let data = new FormData();
                data.append('file',content);
                axios.post(that.Zfip.ip+'/websites/_ext/zhsq/czfmobile/savePicture.jsp',data)
                .then(result=>{
                    if(!result.data.success){
                        that.$toast.fail('图片上传失败，请重试！');
                        file.status='failed'
                        file.message= '上传失败'
                    }else{
                        file.srcs = result.data.result.src
                    }
                })
            }
        },
    },
}
</script>
<style lang="less" scoped>
    .pjmain{
        height: calc(100% - 46px);
        width: 100%;
        background-color: #fff;
    }
    .shangchuan{
        line-height: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        box-sizing: border-box;
        width: 100%;
        padding: 10px 0px;
        overflow: hidden;
        color: #323233;
        font-size: 14px;
        line-height: 24px;
        border-bottom: #f4f4f4 1px solid;
        font-size: 16px;
    }
    .mt10{
        margin-top: 10px;
    }
    .content{
        height: 100%;
        width: 92%;
        margin: 0 4% 0 4%;
        .pjxqtitle{
            height: 100px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-size: 15px;
            border-bottom: #f4f4f4 1px solid;
            span:nth-child(1){
                font-size: 20px;
                color: #333333;
            }
            span:nth-child(2),span:nth-child(3){
                margin-top: 5px;
                color: #999999;
            }
        }
        .bxqk{
            width: 100%;
            line-height: 25px;
            min-height: 150px;
            display: flex;
            flex-direction: column;
            textarea{
                height:125px;
                outline: none;
                border: #dddddd 1px solid;
                border-radius: 20px;
                margin-top: 10PX;
                margin-bottom: 10PX;
                text-indent: 2rem;
                color: #999999;
            }
            span:nth-child(1){
                color: #333333;
            }
            p{
                color: #999999;
                margin: 0;
                padding: 0;
                text-indent: 2rem;
            }
        }
    }
    .daxing{
        display: flex;
        align-items: center;
        span{
            margin-right: 10px;
        }
    }
    .tijiao{
        margin-top: 30px;
        margin-bottom: 30px;
        outline: none;
        border: none;
        border-radius: 10px;
        color: white;
        font-weight: 600;
        background: #28aff6;
        height: 40px;
        margin-left: 15%;
        width: 70%;
        cursor: pointer;
    }
</style>